<template>
  <div class="flex items-center">    
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary ">
      <span>Edit</span>
    </router-link> &nbsp; &nbsp; 
    <router-link :to="del_url" @click.stop.prevent class="text-inherit hover:text-primary ">
      <span>Delete</span>
    </router-link>
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          url() {
            return "/learninghubcategories/edit/"+this.params.data.id
          },
          del_url() {
            return "/learninghubcategories/delete/"+this.params.data.id
          }
        }
    }
</script>
